
define('tpl!taoQtiItem/qtiCreator/tpl/forms/interactions/gapMatch', ['handlebars'], function(hb){ 
return hb.template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helper, options, self=this, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression;

function program1(depth0,data) {
  
  
  return "checked=\"checked\"";
  }

  buffer += "<div class=\"panel\">\n    <label>\n        <input name=\"shuffle\" type=\"checkbox\" ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.shuffle), {hash:{},inverse:self.noop,fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "/>\n        <span class=\"icon-checkbox\"></span>\n        "
    + escapeExpression((helper = helpers.__ || (depth0 && depth0.__),options={hash:{},data:data},helper ? helper.call(depth0, "Shuffle choices", options) : helperMissing.call(depth0, "__", "Shuffle choices", options)))
    + "\n    </label>\n    <span class=\"icon-help tooltipstered\" data-tooltip=\"~ .tooltip-content:first\" data-tooltip-theme=\"info\"></span>\n    <span class=\"tooltip-content\">\n        "
    + escapeExpression((helper = helpers.__ || (depth0 && depth0.__),options={hash:{},data:data},helper ? helper.call(depth0, "If the shuffle attribute is true then the delivery engine will randomize the order in which the choices are initially presented.\n        However each choice may be \"shuffled\" of \"fixed\" individually.", options) : helperMissing.call(depth0, "__", "If the shuffle attribute is true then the delivery engine will randomize the order in which the choices are initially presented.\n        However each choice may be \"shuffled\" of \"fixed\" individually.", options)))
    + "\n    </span>\n</div>";
  return buffer;
  });
});

